import axios from 'axios';

export default {
  selectors: (params = {}, config = {}) => axios.get('quotes/selectors', { params, ...config }),
  quoteTypeSelectors: (params = {}, config = {}) => axios.get('quotes/types/selectors', { params, ...config }),
};
